module.exports = __webpack_public_path__ + "img/item7.a52e8698.svg";